import { render } from "./ProjectOneImage.vue?vue&type=template&id=05dc1d3e"
import script from "./ProjectOneImage.vue?vue&type=script&lang=js"
export * from "./ProjectOneImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__